import angular from 'angular';
import { FgFileListServiceType } from '../files/file.listService';
import { SharedAngular } from '@Shared.FormGen/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';

angular
  .module('fg')
  .directive('fgFieldFileUpload', [
    'fgFieldFileUploadLinkFn',
    function (fgFieldFileUploadLinkFn) {
      //See: https://bizflo.atlassian.net/wiki/spaces/TECH/pages/50987034/Notes+On+File+Upload

      return {
        replace: true,
        controllerAs: 'ctrl',
        controller: [
          '$http',
          '$q',
          'sessionService',
          'fgFileListService',
          '$scope',
          'browserUtilsService',
          function (
            $http,
            $q,
            sessionService,
            fgFileListService: FgFileListServiceType,
            $scope,
            browserUtilsService
          ) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const ctrl = this;
            ctrl.showErrorStyles = showErrorStyles;
            ctrl.fgFileListService = fgFileListService;
            ctrl.addFile = addFile;
            $scope.isMobileApp = browserUtilsService.isCordovaApp();

            function addFile(file) {
              fgFileListService.addFile(file, ctrl.fieldId, ctrl.stepId);
            }

            function showErrorStyles() {
              const fileCount = fgFileListService.getFileListFileCount(
                ctrl.fieldId,
                ctrl.stepId
              );

              return (
                fileCount == 0 &&
                fgFileListService.isFileRequired(ctrl.fieldId, ctrl.stepId) &&
                (fgFileListService.isFileListDirty(ctrl.fieldId, ctrl.stepId) ||
                  (ctrl.form.state && ctrl.form.state.$submitted))
              );
            }
          }
        ],
        templateUrl:
          'angular-form-gen/field-templates/default/fileupload.ng.html',
        link: fgFieldFileUploadLinkFn
      };
    }
  ])
  .factory('fgFieldFileUploadLinkFn', [
    'pubsubService',
    'fileService',
    function (pubsubService, fileService: SharedAngular.FileService) {
      return function ($scope, $element, $attrs, ctrls) {
        ctrls.fieldId = $attrs.fileControlId;
        ctrls.stepId = $attrs.fileStepId;
        ctrls.form = $scope.$parent.form;

        initialiseFiles();

        $scope.$watch(function () {
          return ctrls.form.data && ctrls.form.data[ctrls.fieldId];
        }, initialiseFiles);

        //if there is a file already uploaded against this step, add it to the list
        function initialiseFiles() {
          ctrls.fgFileListService.removeFilesForStepField(
            ctrls.stepId,
            ctrls.fieldId
          );
          if (ctrls.form.data && ctrls.form.data[ctrls.fieldId]) {
            const files = ctrls.form.data[ctrls.fieldId];

            for (let f = 0; f < files.length; f++) {
              getFile(files[f].fileId, files[f].downloadLink);
            }
          }
        }

        function getFile(fileId: Guid, downloadLink: string) {
          fileService.getFileMetaData(fileId).then(function (fileData) {
            if (!fileData) {
              return;
            }

            const file = {
              filename: fileData.filename,
              //take the last guid in the string this is the ID
              id: fileId,
              key: ctrls.fieldId,
              downloadLink: downloadLink,
              size: fileData.size
            };
            //for it to show up in the control it needs to be added to the file list
            ctrls.addFile(file);
            pubsubService.publish('FILEUPLOAD_UPLOAD_COMPLETED');
          });
        }
      };
    }
  ]);
